import { render, staticRenderFns } from "./CourseEditTabInformation.vue?vue&type=template&id=291bff2a&"
import script from "./CourseEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CourseEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./CourseEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports